import React, { useEffect, useState } from "react";
import { Grid, Message } from "semantic-ui-react";

import Card from "../../UI/Card/Card";
import EpcDataSummary from "./EpcDataSummary";
import EpcDataBreakdown from "./EpcDataBreakdown";
import Preloader from "../../UI/Preloader/Preloader";

import { useTeamContext } from "../../../contexts/TeamContext";
import { useRestClientContext } from "../../../contexts/RestClientContext";

export const epcGrades = ["A", "B", "C", "D", "E", "F", "G", "Ungraded"] as const;
export type EpcGrade = (typeof epcGrades)[number];

const EpcData = () => {
	const team = useTeamContext();
	const client = useRestClientContext();
	const [epcOverview, setEpcOverview] = useState();
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<string>("");

	useEffect(() => {
		setLoading(true);

		client
			.fetchEpcDataOverview(team.id)
			.then((response: Response) => response.json())
			.then((json: any) => {
				setLoading(false);
				setEpcOverview(json);
			})
			.catch((_) => {
				setLoading(false);
				setError("Error fetching EPC data");
			});
	}, [team, client]);

	return (
		<Card title="EPC Data" minHeight={395}>
			{loading ? (
				<Preloader />
			) : error ? (
				<Message error>{error}</Message>
			) : epcOverview ? (
				<Grid stackable columns={2} padded="vertically">
					<Grid.Column>
						<div className="epc-data-label">
							<EpcDataSummary data={epcOverview} />
						</div>
					</Grid.Column>
					<Grid.Column>
						<EpcDataBreakdown data={epcOverview} />
					</Grid.Column>
				</Grid>
			) : (
				<Message>No data</Message>
			)}
		</Card>
	);
};

export default EpcData;
